import axios from "../../libs/netAxios"
import { SigninToMerchantAppResponse } from "@/types/interface/User/UserTypes"
import qs from "qs"

export const merchSignin = async (): Promise<SigninToMerchantAppResponse> => {
  const { data } = await axios.request({
    method: "POST",
    url: "/api/User/merchSignin",
  })
  return data
}

// /User/merchSignin

export const merchInfo = async (id: string) => {
  const { data } = await axios.request({
    method: "GET",
    url: "/api/Merch/get",
    params: {
      id,
    },
  })
  return data
}

export const merchBaseSetting = async (merchIds: string[]) => {
  const { data } = await axios.request({
    method: "GET",
    url: "api/Merch/getByIds",
    params: {
      merchIds,
    },
    paramsSerializer: (merchIds: string[]) => {
      return qs.stringify(merchIds, { indices: false })
    },
  })
  return data
}
